/* === BEGIN imported: includes/files-constants.js (verbatim from plugin) === */
import {BOOKING_CONSTRAINTS} from '@/constants/booking'
import { tripNow, parseRideDate } from '@/utils/dateUtils.js'

// Only ever called with a stored RIDE_DATE, which is a bare "YYYY-MM-DD" — new Date()
// would read that as UTC midnight and render the PREVIOUS day west of UTC, so the
// "Pick up at ..." label showed the wrong date. parseRideDate keeps the picked day and
// passes any other shape through unchanged.
export const NGD_formatDate = (dateString) => {
    const d = parseRideDate(dateString);
    if (!d) return "";
    return d.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
    });
};

export const NGD_formatTime = (dateString) => {
    const d = new Date(dateString);
    return d.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
    });
};

// Returns undefined when the cars haven't been fetched yet — callers treat that as
// "not ready" (`|| {}` / a loader). The cache is legitimately ABSENT at this point:
// travelingDateTime removes it before navigating whenever a recalc is needed, and
// selectedCarDetailsLatest now renders straight after (carSelection used to sit in
// between and fetch first). JSON.parse(null) returns null, so the guard is required —
// without it this threw "Cannot read properties of null (reading 'find')".
export const filterSelectedCarDetails = () => {
    const allCarsApiData = sessionStorage.getItem("hopnAllCarsApiData");
    const selectedCarId = sessionStorage.getItem("hopnPassengerCar");
    const allCarsDetails = allCarsApiData ? JSON.parse(allCarsApiData) : [];
    if (!Array.isArray(allCarsDetails)) return undefined;
    return allCarsDetails.find(item => String(item.vehicle_type_id) === String(selectedCarId)) || allCarsDetails[0];
};

export const getHopnMinDate = () => {
    const now = tripNow();

    const lastSlotToday = tripNow();
    lastSlotToday.setHours(BOOKING_CONSTRAINTS.LATEST_BOOKING_HOUR, BOOKING_CONSTRAINTS.LATEST_BOOKING_MINUTE, 0, 0);

    if (now > lastSlotToday) {
        const tomorrow = tripNow();
        tomorrow.setDate(now.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        return tomorrow;
    }

    return now;
};

export const getHopnMaxDate = () => {
    const now = tripNow();
    const max = new Date(now);
    max.setDate(max.getDate() + BOOKING_CONSTRAINTS.MAX_BOOKING_ADVANCE_DAYS);
    max.setHours(23, 59, 59, 999);
    return max;
};
/* === END imported: includes/files-constants.js === */
